import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { api } from "../../../../api";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const Role3 = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [roledata, setroledata] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    // Fetch data and set departdata
    const fetchData = async () => {
      try {
        const response = await api.get(`addRole.php`);
        setroledata(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the fetchData function
  }, []); // Empty dependency array to run only once when component mounts

  useEffect(() => {
    // Filter the data when searchQuery or roledata changes
    const originalData = roledata || [];
    const filtered = originalData.filter((item) =>
      (item.role_name || "").toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchQuery, roledata]); // Dependency array includes searchQuery and roledata

  const [itemIdToDelete, setItemIdToDelete] = useState(null);

  const handleDeleteIconClick = (role_id) => {
    setItemIdToDelete(role_id);
    setShowDeleteConfirmation(true);
  };

  const handleEditClick = (role_id) => {
    navigate(`/hr-admin/hr-management/edit-role/${role_id}`);
  };

  const handleDeleteConfirmation = (e) => {
    // e.preventDefault();
    // Implement delete logic here
    const roleid = itemIdToDelete;
    if (roleid != null) {
      const fetchData = async () => {
        try {
          const response = await api.get(`addRole.php?roleid=${roleid}`);
          console.log(response.data);
          window.location.reload();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
    setItemIdToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const [showRoleModal, setShowRoleModal] = useState(false);

  const toggleRole = () => {
    setShowRoleModal(!showRoleModal);
  };

  const [role, setrole] = useState({ role: "", capacity: "" });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setrole((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    console.log(role);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        role: role.role,
        capacity: role.capacity,
      };
      await api.post("addRole.php", payload);
      setSuccessMessage("Role added successfully!");
      setTimeout(() => {
        setSuccessMessage("");
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const [viewrole, setviewrole] = useState();
  const [loading, setLoading] = useState(true);

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="mb-5">
            <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
              <h1 className="text-black mb-0 font-bold">Roles List</h1>
            </Col>

            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex ">
               <Form
                      className="navbar-search px-2 w-100"
                      style={{ maxWidth: '300px' }}
                    >
                      <FormGroup className="mb-0 w-100">
                        <InputGroup className="input-group-alternative align-items-center h-[40px]">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="border-right-0 h-[38px]">
                              <i className="fas fa-search text-black px-2" />
                              <Input
                                placeholder="Search Role"
                                type="text"
                                className="border-left-0 ml-2 h-[38px]"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                              />
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </Form>
              {/* <Button className="ml-4" onClick={toggleRole}>
                Add Role
              </Button> */}
            </Col>
          </Row>

          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card
                className=""
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                }}
              >
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr style={{ textAlign: "center" }}>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        S.No
                      </th>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        Role
                      </th>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        Capacity
                      </th>
                      <th
                        style={{
                          fontSize: "14px",
                          color: "black",
                          fontWeight: "700",
                        }}
                        scope="col"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "center" }}>
                    {filteredData && filteredData.length > 0 && filteredData.map((item, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>{item.role_name}</td>
                        <td>{item.capacity}</td>
                        <td>
                          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                            <Tippy content="Edit Details">
                              <i
                                className="fa fa-edit"
                                style={{
                                  fontSize: "20px",
                                  color: "#000000",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleEditClick(item.id)}
                              ></i>
                            </Tippy>
                            {/* <Tippy content="Delete">
                              <i
                                className="fa fa-trash"
                                style={{
                                  fontSize: "20px",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleDeleteIconClick(item.id)}
                              ></i>
                            </Tippy> */}
                          </div>
                        </td>
                      </tr>
                    ))}
                    {filteredData && filteredData.length === 0 && (
                      <tr>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                          No role found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={showDeleteConfirmation}
        toggle={() => setShowDeleteConfirmation(false)}
      >
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalBody>Are you sure you want to delete this role ?</ModalBody>
        <div className="modal-footer">
          <Button color="danger" onClick={handleDeleteConfirmation}>
            Yes
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowDeleteConfirmation(false)}
          >
            No
          </Button>
        </div>
      </Modal>

      <Modal isOpen={showRoleModal} toggle={toggleRole}>
        <ModalHeader toggle={toggleRole}>
          <h2 style={{ fontWeight: "bolder", textTransform: "uppercase" }}>
            New Role
          </h2>
        </ModalHeader>
        <ModalBody>
          {/* Success Alert */}
          {successMessage && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div
                className="alert alert-success text-center"
                role="alert"
                style={{ maxWidth: "400px", width: "100%" }}
              >
                {successMessage}
              </div>
            </div>
          )}
          <Form onSubmit={handleFormSubmit}>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <label className="form-control-label" htmlFor="input-role">
                    Enter Role *
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-role"
                    type="text"
                    name="role"
                    pattern="^[a-zA-Z ]+$"
                    title="Enter letters only"
                    onChange={handleInputChange}
                    placeholder="Enter Role Name"
                    required
                  />
                  <label className="form-control-label" htmlFor="input-role">
                    Enter Capacity <span style={{color: 'red'}}>*</span>
                  </label>
                  <Input
                    className="form-control-alternative"
                    id="input-role"
                    type="select"
                    name="capacity"
                    onChange={handleInputChange}
                    placeholder="Enter Capacity of handling projects"
                    required
                  >
                    <option value="">Select Capacity</option>
                    <option value="Not Applicable">Not Applicable</option>
                    {[...Array(6)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{ textAlign: "center" }}>
                <Button
                  style={{
                    backgroundColor: "#d86f89",
                    borderColor: "#d86f89",
                    color: "black",
                  }}
                  type="submit"
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Role3;
